import React, { useContext, useEffect, useState } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { Rating } from "react-simple-star-rating";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import
import { Modal } from "react-bootstrap";
import { encryptAndStore } from "../../helper/sessionStore";
import { CourseContext } from "../../context/CourseContext";
import { decryptFromStoreLoc } from "../../helper/localStore";
function AIShareYourFeedback() {
    const { t } = useTranslation("AIShareYourFeedback");
    const { setEmail } = useContext(CourseContext);
    const navigate = useNavigate();
    const location = useLocation();
    const [rating, setRating] = useState(0);
    const [feedback, setFeedback] = useState("");

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleRating = (rate) => {
        setRating(rate);
    };

    useEffect(() => {
        if (!location?.state?.step || !location?.state?.trailId) {
            navigate("/sign-in");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleRegister = () => {
        const data = decryptFromStoreLoc("AIUserData");
        if (data) {
            setEmail(data.email);
            encryptAndStore("role", 12);
            setTimeout(() => {
                navigate("/user-details", {
                    state: {
                        sendCertificate: true,
                    },
                });
            }, 1000);
        } else {
            navigate("/sign-up");
        }
    };

    const handleWhyUnicorso = () => {
        const data = decryptFromStoreLoc("AIUserData");
        if (data) {
            setEmail(data.email);
            encryptAndStore("role", 12);
            navigate("/advantages", {
                state: {
                    step: location?.state?.step,
                    trailId: location?.state?.trailId,
                },
            });
        } else {
            navigate("/sign-up");
        }
    };

    return (
        <>
            <Header />
            <section className="py-5 training_topics">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="card border-0 question_card_box">
                                <div className="card-body">
                                    <h3>{t("feedback")} </h3>
                                    <img
                                        className="feedback_vector"
                                        src="/new-business/feedback0.webp"
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 ps-xl-5 question_card_details mt-4 mt-md-5 mt-xl-0">
                            <h3>
                                {t("tellmehelp")}{" "}
                                <span className="optional">
                                    {" "}
                                    {t("optional")}{" "}
                                </span>
                            </h3>
                            <div className="your_rating_box">
                                <h4> {t("yourrating")} </h4>
                                <div className="star-rating">
                                    <Rating
                                        ratingValue={rating}
                                        size={30}
                                        transition
                                        fillColor="orange"
                                        emptyColor="gray"
                                        onClick={handleRating}
                                    />
                                </div>
                            </div>
                            <textarea
                                rows="10"
                                className="form-control pt-2 mt-3 ai-textarea"
                                placeholder={t("typeFeedbackHere")}
                                id="floatingTextarea2"
                                onChange={(e) => setFeedback(e.target.value)}
                                value={feedback}
                            />

                            <div className="d-flex justify-content-end align-items-end pt-4 pb-md-5">
                                <button
                                    // onClick={handleSkip}
                                    onClick={handleShow}
                                    className="skip_btn"
                                >
                                    {t("skip")}
                                </button>
                                <button
                                    // onClick={handleSubmit}
                                    onClick={handleShow}
                                    className="btn-explore p-sm-15 d-flex justify-content-between align-items-center gap-3 rounded-2 mt-md-4"
                                >
                                    {t("sendfeedback")}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={22}
                                        height={14}
                                        viewBox="0 0 22 14"
                                        fill="none"
                                        className="ms-3"
                                    >
                                        <path
                                            d="M1 6.99854H21L16 1"
                                            stroke="white"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M21 6.99805L16 12.9995"
                                            stroke="white"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Modal
                className="send_certificate_modal"
                show={show}
                centered
                size="lg"
                onHide={handleClose}
            >
                <Modal.Body>
                    <button
                        className="btn-close close-modal"
                        onClick={handleClose}
                    ></button>
                    <div>
                        <p className="mb-4">{t("modeldescription")}</p>
                        <div className="d-flex align-items-center justify-content-end gap-3">
                            <button
                                className="btn-secondary"
                                onClick={handleRegister}
                            >
                                {t("sendcertificate")}
                            </button>
                            <button
                                className="btn-primary"
                                onClick={handleWhyUnicorso}
                            >
                                {t("whyunicorso")}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AIShareYourFeedback;
